/* Umall recipes: buy-all list and video on the recipe page.

   Buy-all list
   - quantities: packs = ceil(grams needed for the chosen servings / usable grams per pack), at least 1
   - each ingredient has a first choice and up to 3 swaps. A swap is either "same" (the same ingredient in another
     brand or size, picked automatically when the first choice is sold out) or "sub" (a different ingredient that
     still works in this dish). A "sub" is used only when the first choice and every "same" swap are sold out; it is then
     ticked too (main ingredients; pantry rows only suggest it), and the shopper is told in plain words: the line says
     "Swapped for a different ingredient", and one sentence above the list and in the result names the swap
   - the same purchase limits as the cart (flash sales, short-dated clearance...): never more than the limit per product,
     counting what is already in the cart; anything above the limit comes from the next same-kind swap
   - Daily Essentials: first unit at the hook price, the rest at the normal price; clearance items show their date
   - availability and prices are rechecked live from /products/<handle>.js because pages are cached
   - one /cart/add.js call; after any error, read the cart and add only missing quantities;
     afterwards the theme's mini cart and cart guards are refreshed and the cart is checked against what was intended
   - when a main ingredient can't be bought here (first choice and same-kind swaps all sold out), one plain
     summary line above the list and in the result names it, suggests a local supermarket and any substitute;
     the recipe's ingredient list marks every such ingredient
   - in-page links (Ingredients, Method, Video...) stop below the theme's sticky header

   Video: muted until the shopper turns the sound on; plays (muted) only while on screen; once the shopper has
   paused it, switched tab or left the window, it never starts by itself again.

   Test: ?ur_test_soldout=<variant id>,...  sold out; ?ur_test_gone=<variant id>,...  removed from the store;
         ?ur_test_incart=<product id>,...  pretend one unit of that product is already in the cart. */
(function () {
  'use strict';
  var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  var $ = function (id) { return document.getElementById(id); };
  var params = new URLSearchParams(location.search);
  var qaRole = window.Shopify && Shopify.theme && Shopify.theme.role;
  var allowTests = qaRole === 'unpublished' || qaRole === 'development';
  function idList(k) { if (!allowTests) return []; return (params.get(k) || '').split(',').map(function (s) { return Number(s.trim()); }).filter(Boolean); }
  function money(c) { return (c / 100).toFixed(2); }
  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (ch) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[ch]; }); }

  /* ======================= in-page links below the sticky header ======================= */
  var coverCache = 0;
  function topCover() {
    var max = 0, vw = window.innerWidth, vh = window.innerHeight, els = document.body.getElementsByTagName('*');
    for (var i = 0; i < els.length; i++) {
      var e = els[i];
      if (e.closest && e.closest('.ur-buy, .ur-pick, .ur-buybar, .ur-scrim')) continue;
      var cs = getComputedStyle(e);
      if ((cs.position !== 'fixed' && cs.position !== 'sticky') || cs.display === 'none' || cs.visibility === 'hidden') continue;
      var rc = e.getBoundingClientRect();
      if (rc.width < vw * 0.5 || rc.height < 20 || rc.height > vh * 0.45 || rc.top > vh * 0.25) continue;
      max = Math.max(max, rc.top >= 0 ? rc.bottom : rc.height);
    }
    if (max) coverCache = max;
    return max || coverCache;
  }
  function headerGuess() {
    var h = document.querySelector('.ntheader_wrapper, #shopify-section-header, header');
    var rc = h && h.getBoundingClientRect();
    return rc && rc.height < window.innerHeight * 0.45 ? rc.height : 0;
  }
  var jumpId = 0;
  function jumpTo(el, smooth) {
    var gap = 12, id = ++jumpId, userMoved = false;
    function target(cover) { return Math.max(0, el.getBoundingClientRect().top + window.pageYOffset - cover - gap); }
    var cover = topCover() || coverCache || headerGuess();
    window.scrollTo({ top: target(cover), behavior: smooth ? 'smooth' : 'auto' });
    function stop() { userMoved = true; }
    ['wheel', 'touchstart', 'keydown'].forEach(function (k) { window.addEventListener(k, stop, { once: true, passive: true }); });
    function fix() {
      if (userMoved || id !== jumpId) return;
      var t = target(topCover() || cover);
      if (Math.abs(t - window.pageYOffset) > 2) window.scrollTo({ top: t, behavior: 'auto' });
    }
    var first = false;
    function settle() { if (first) return; first = true; fix(); setTimeout(fix, 450); setTimeout(fix, 1100); }
    if ('onscrollend' in window) window.addEventListener('scrollend', settle, { once: true });
    setTimeout(settle, smooth ? 1300 : 250);
  }

  /* ======================= video: never grab the shopper's attention ======================= */
  (function video() {
    var box = document.querySelector('.ur-video');
    var v = box && box.querySelector('video');
    if (!v) return;
    var sound = box.querySelector('[data-ur-sound]'), end = box.querySelector('[data-ur-end]');
    // poster: only fetched when the video is about a screen away, so it does not compete with the hero photo
    var pst = v.getAttribute('data-poster');
    if (pst) {
      if ('IntersectionObserver' in window) {
        var po = new IntersectionObserver(function (es) { if (es.some(function (e) { return e.isIntersecting; })) { v.poster = pst; po.disconnect(); } }, { rootMargin: '2500px 0px' });
        po.observe(v);
      } else { v.poster = pst; }
    }
    var noAuto = false, ours = false; // noAuto: the shopper paused it, or left the tab/window -> no more autoplay
    v.muted = true;
    function playQuiet() {
      if (noAuto || !v.muted || document.visibilityState !== 'visible') return;
      if (v.preload === 'none') v.preload = 'auto';
      ours = true;
      var p = v.play();
      if (p && p.catch) p.catch(function () {});
      setTimeout(function () { ours = false; }, 300);
    }
    function pauseQuiet() { if (!v.paused) { ours = true; v.pause(); setTimeout(function () { ours = false; }, 300); } }
    function syncSound() { if (sound) sound.hidden = !v.muted; }
    if (sound) sound.addEventListener('click', function () {
      v.muted = false; noAuto = true; if (end) end.hidden = true;
      var p = v.play(); if (p && p.catch) p.catch(function () {});
    });
    v.addEventListener('volumechange', syncSound);
    v.addEventListener('pause', function () { if (!ours && !v.ended) noAuto = true; });
    v.addEventListener('play', function () { if (end) end.hidden = true; });
    v.addEventListener('ended', function () { noAuto = true; if (end) end.hidden = false; });
    if (end) end.querySelector('[data-ur-replay]').addEventListener('click', function () { end.hidden = true; v.currentTime = 0; v.play(); });
    document.addEventListener('visibilitychange', function () { if (document.visibilityState !== 'visible') { noAuto = true; pauseQuiet(); } });
    window.addEventListener('blur', function () { noAuto = true; });
    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (es) {
        es.forEach(function (e) { if (e.intersectionRatio >= 0.6) playQuiet(); else if (v.muted) pauseQuiet(); });
      }, { threshold: [0, 0.6] }).observe(v);
    }
    syncSound();
  })();

  /* ======================= buy-all list ======================= */
  var dataEl = $('ur-data');
  var D = null;
  try { D = dataEl && JSON.parse(dataEl.textContent); } catch (e) { D = null; }
  if (!D) { bindJumps(); return; }

  var base = D.base || 1, serves = base, MAX_SERVES = 12;
  var testOut = idList('ur_test_soldout'), testGone = idList('ur_test_gone'), testInCart = idList('ur_test_incart');
  var cart = null, cartQty = {}, cartTotal = 0;
  var pending = false, added = false, attempt = null;
  var list = $('ur-list'), addBtn = $('ur-add'), msg = $('ur-msg'), free = $('ur-free');
  var mq = window.matchMedia('(max-width: 860px)');

  function name(c) { return c.t + (c.vt ? ' – ' + c.vt : ''); }
  function live(c) { return c && !c.gone; }
  function avail(c) { return c && c.a && !c.gone; }
  function prim(r) { for (var i = 0; i < r.c.length; i++) if (r.c[i].pri) return r.c[i]; return null; }
  function plural(n, w) { return n + ' ' + w + (n > 1 ? 's' : ''); }
  function lineCost(c, q) { return c.de ? c.de.h + Math.max(0, q - 1) * c.de.n : c.p * q; }
  function lineWas(c, q) { return c.de ? c.p * q : (c.cp > c.p ? c.cp * q : 0); }
  function usable(c) { return c.n ? c.n * (c.yl || 1) : 0; }
  function needG(r) { return r.g * serves / base; }
  function packsFor(r, c) {
    var need = needG(r), u = usable(c);
    if (!u || !need) return 1;
    return Math.max(1, Math.ceil(need / u - 1e-9));
  }

  var rows = D.rows.map(function (r, i) {
    r.c.forEach(function (c) {
      c.kd = c.pri ? 'same' : (c.kd || 'same');
      if (testOut.indexOf(c.id) >= 0) { c.a = false; c.test = true; }
      if (testGone.indexOf(c.id) >= 0) { c.a = false; c.gone = true; c.test = true; }
    });
    return { i: i, r: r, sel: -1, on: false, user: false, plan: [], notes: [], suggest: false };
  });

  /* which candidates to try, in which order */
  function sameKind(r) { return r.c.filter(function (c) { return c.kd === 'same' && avail(c); }); }
  function orderFor(st) {
    var r = st.r;
    if (st.user && st.sel >= 0) {
      var chosen = r.c[st.sel];
      if (!avail(chosen)) return [];
      // the shopper's pick first; any shortfall (limit, stock) from other candidates of the same kind
      return [chosen].concat(r.c.filter(function (c) { return c !== chosen && c.kd === chosen.kd && avail(c); }));
    }
    if (st.auto2 && st.sel >= 0) {
      var sub0 = r.c[st.sel];
      return avail(sub0) ? [sub0].concat(r.c.filter(function (c) { return c !== sub0 && c.kd === 'sub' && avail(c); })) : [];
    }
    var same = sameKind(r);
    if (r.pick === 'best_fit' && same.length > 1) {
      same = same.slice().sort(function (a, b) {
        var pa = packsFor(r, a), pb = packsFor(r, b);
        return (lineCost(a, pa) - lineCost(b, pb)) || (pa - pb) || (r.c.indexOf(a) - r.c.indexOf(b));
      });
    }
    return same;
  }

  /* allocate the packs for one row, respecting limits and stock; `taken` counts what earlier rows already use */
  function planRow(st, taken) {
    var r = st.r, order = orderFor(st), plan = [], notes = [];
    var left = needG(r) || 0, unitsOnly = !left;
    for (var i = 0; i < order.length; i++) {
      var c = order[i];
      var want = unitsOnly ? 1 : (usable(c) ? Math.max(1, Math.ceil(left / usable(c) - 1e-9)) : 1);
      var room = Infinity;
      if (c.lim) {
        var inCart = (cartQty[c.pid] || 0) + (taken.p[c.pid] || 0);
        room = Math.max(0, c.lim - inCart);
        if (room <= 0) { notes.push(c.t + ' is limited to ' + c.lim + ' per order' + ((cartQty[c.pid] || 0) ? ' and is already in your cart' : '')); continue; }
      }
      if (c.q != null) {
        var stockLeft = Math.max(0, c.q - (taken.v[c.id] || 0));
        if (stockLeft <= 0) continue;
        if (stockLeft < want) notes.push('Only ' + stockLeft + ' left of ' + c.t);
        room = Math.min(room, stockLeft);
      }
      var q = Math.min(want, room);
      plan.push({ c: c, q: q });
      taken.p[c.pid] = (taken.p[c.pid] || 0) + q;
      taken.v[c.id] = (taken.v[c.id] || 0) + q;
      if (unitsOnly || !usable(c)) { left = 0; break; }
      left -= q * usable(c);
      if (left <= 1e-6) break;
    }
    st.short = plan.length > 0 && left > 1e-6 && !unitsOnly;
    st.plan = plan; st.notes = notes;
  }

  /* choose what each row shows when nothing was picked by hand */
  function autoPick(st) {
    var r = st.r, same = orderFor({ r: r, user: false, sel: -1 });
    st.suggest = false; st.auto2 = false;
    if (same.length) { st.sel = r.c.indexOf(same[0]); if (!st.user) st.on = !r.pantry; return; }
    var sub = r.c.filter(function (c) { return c.kd === 'sub' && avail(c); })[0];
    // a different ingredient: ticked for main ingredients (and said so), only suggested for pantry staples
    if (sub) { st.sel = r.c.indexOf(sub); st.suggest = !!r.pantry; st.auto2 = !r.pantry; if (!st.user) st.on = !r.pantry; return; }
    st.sel = -1; st.on = false;
  }

  function planAll() {
    var taken = { p: {}, v: {} };
    rows.forEach(function (st) {
      if (!st.user) autoPick(st);
      if (st.on && st.sel >= 0) planRow(st, taken);
      else { st.plan = st.sel >= 0 ? [{ c: st.r.c[st.sel], q: packsFor(st.r, st.r.c[st.sel]) }] : []; st.notes = []; st.short = false; }
    });
  }

  function forText(st) {
    var r = st.r;
    if (serves === base || !r.g) return r.qty + ' ' + r.label;
    return Math.round(needG(r)) + ' g ' + r.label;
  }
  function thumb(c) {
    return c && c.img ? '<img class="ur-thumb" src="' + esc(c.img) + '" alt="" width="56" height="56" loading="lazy">' : '<span class="ur-thumb is-blank"></span>';
  }
  function primaryProblem(r) {
    var p = prim(r);
    if (r.gone || (p && p.gone)) return { who: p ? p.t : null, why: 'isn’t stocked right now' };
    if (p && !p.a) return { who: p.t, why: 'is sold out' };
    return null;
  }
  function badges(c) {
    var b = '';
    if (c.lim) b += '<span class="ur-badge ur-badge--lim">' + esc(c.lm || ('Limit ' + c.lim + ' per order')) + '</span>';
    if (c.de) b += '<span class="ur-badge ur-badge--de">Daily Essential: first A$' + money(c.de.h) + ', then A$' + money(c.de.n) + ' each</span>';
    if (c.cl) b += '<span class="ur-badge ur-badge--cl">' + esc(c.cl) + '</span>';
    return b;
  }

  function rowHTML(st) {
    var r = st.r, p = prim(r), c = r.c[st.sel];
    var anyLive = r.c.filter(live).length > 0;
    var out = st.sel < 0;
    var blocked = st.on && st.sel >= 0 && !st.plan.length; // e.g. at its per-order limit already
    var plan = st.plan.length ? st.plan : (c ? [{ c: c, q: packsFor(r, c) }] : []);
    var lead = plan[0] ? plan[0].c : (p || r.c.filter(live)[0]);
    var cls = 'ur-row' + (out ? ' is-out' : '') + (!st.on || blocked ? ' is-off' : '') + (st.suggest && !st.on ? ' is-sub' : '');
    var h = '<div class="' + cls + '" data-i="' + st.i + '">';
    h += '<button type="button" class="ur-cb" role="checkbox" aria-checked="' + (st.on ? 'true' : 'false') + '" aria-label="Include ' + esc(r.label) + '"' + (out ? ' disabled' : '') + '></button>';
    h += thumb(anyLive ? lead : null);
    h += '<div class="ur-name">';
    if (!anyLive) h += esc(r.qty + ' ' + r.label);
    else if (lead) h += '<a href="' + esc(lead.u) + '">' + esc(name(lead)) + '</a>';
    if (anyLive) {
      var packs = plan.reduce(function (s, l) { return s + l.q; }, 0);
      h += '<span class="ur-for">for ' + esc(forText(st)) + (plan.length ? ' · ' + plural(packs, 'pack') : '') + '</span>';
    }
    if (plan.length > 1 && st.on) {
      h += '<span class="ur-split">' + plan.map(function (l) { return l.q + ' × ' + esc(name(l.c)); }).join(' + ') + '</span>';
    }
    plan.forEach(function (l) { h += badges(l.c); });
    if (lead && lead.nt && !lead.pri) h += '<span class="ur-note2">' + esc(lead.nt) + '</span>';
    st.notes.forEach(function (n) { h += '<span class="ur-note3">' + esc(n) + '.</span>'; });
    if (st.short) h += '<span class="ur-note3">Not enough in stock for the full amount; we added what we could.</span>';
    var prob = primaryProblem(r);
    if (!anyLive) {
      h += '<span class="ur-sold">Not stocked at Umall right now</span>';
    } else if (out) {
      h += '<span class="ur-sold">' + (r.c.filter(live).length > 1 ? 'Sold out, and so are the swaps' : 'Sold out') + '</span>';
    } else if (blocked) {
      h += '<span class="ur-sold">Won\u2019t be added: it\u2019s at its per-order limit</span>';
    } else if (st.suggest && !st.on) {
      h += '<span class="ur-sub">' + (prob && prob.who ? esc(prob.who) + ' ' : 'The usual pick ') + prob_why(prob) + '. Substitute: tick to add, or <button type="button" class="ur-chg" data-chg>choose</button></span>';
    } else if (!st.user && st.auto2 && st.on && lead && lead.kd === 'sub') {
      h += '<span class="ur-swap ur-swap2">Swapped for a different ingredient: ' + (prob && prob.who ? esc(prob.who) + ' ' : 'our usual pick ') + prob_why(prob) + ' · <button type="button" class="ur-chg" data-chg>Change</button></span>';
    } else if (lead && !lead.pri && lead.kd === 'same' && prob) {
      h += '<span class="ur-swap">Swapped: ' + (prob.who ? esc(prob.who) + ' ' : 'our usual pick ') + prob.why + ' · <button type="button" class="ur-chg" data-chg>Change</button></span>';
    } else if (lead && lead.kd === 'sub' && st.on) {
      h += '<span class="ur-sub">Substitute you chose · <button type="button" class="ur-chg" data-chg>Change</button></span>';
    } else if (r.c.filter(live).length > 1) {
      h += '<span class="ur-chg-plain"><button type="button" class="ur-chg" data-chg>Change</button></span>';
    }
    h += '</div>';
    if (plan.length && !blocked) {
      var cost = 0, was = 0;
      plan.forEach(function (l) { cost += lineCost(l.c, l.q); was += lineWas(l.c, l.q) || lineCost(l.c, l.q); });
      h += '<div class="ur-price">A$' + money(cost) + (was > cost ? '<s>A$' + money(was) + '</s>' : '') + '</div>';
    } else {
      h += '<div class="ur-price">—</div>';
    }
    return h + '</div>';
  }
  function prob_why(prob) { return prob ? prob.why : 'is sold out'; }

  /* ---------- what can't be bought here right now ---------- */
  // Main ingredients that won't go in the cart because the first choice and every same-kind swap are sold out
  // (a substitute may still be suggested). A row the shopper unticked on purpose, or whose substitute they ticked, is not counted.
  function missingRows() {
    return rows.filter(function (st) { return !st.r.pantry && !st.on && (st.sel < 0 || st.suggest); });
  }
  // product title without a trailing pack size, to read well in a sentence ("Premium Chicken Breast Fillet- 1kg" -> "Premium Chicken Breast Fillet")
  function plainName(c) { return c.t.replace(/\s*[-–,]?\s*(?:pack of \d+|\d[\d.]*\s*(?:g|kg|ml|l|pieces?|pcs|packs?))\s*$/i, '') || c.t; }
  function andList(a) { return a.length < 2 ? a.join('') : a.slice(0, -1).join(', ') + ' and ' + a[a.length - 1]; }
  // done: after an add (anyAdded: something went in the cart); otherwise the wording before adding
  function missingText(done, anyAdded) {
    var miss = missingRows(), n = miss.length;
    if (!n) return '';
    var others = done ? anyAdded : rows.some(function (st) { return st.on && st.plan.length; });
    var t = (n === 1 ? '1 ingredient isn’t' : n + ' ingredients aren’t') + ' available at Umall right now: ' +
      andList(miss.map(function (st) { return st.r.label; })) + '. You can grab ' + (n === 1 ? 'it' : 'them') + ' from any local supermarket' +
      (others ? (done ? ' — everything else is in your cart.' : ' — we’ll add everything else.') : '.');
    miss.forEach(function (st) {
      if (!st.suggest) return;
      t += (n === 1 ? ' Or use ' : ' For ' + st.r.label + ', you could use ') + plainName(st.r.c[st.sel]) + ' instead' + (done ? '.' : ' (tick it in the list).');
    });
    return t;
  }
  // main ingredients swapped for a different ingredient (every same-kind choice sold out)
  function subRows() {
    return rows.filter(function (st) { return !st.user && st.auto2 && st.on && st.plan.length && st.plan[0].c.kd === 'sub' && !st.r.pantry; });
  }
  function subText(done) {
    var sr = subRows(), n = sr.length;
    if (!n) return '';
    return 'Heads up: we' + (done ? ' were' : '’re') + ' out of ' + andList(sr.map(function (st) { return st.r.label; })) + ', so ' +
      (done ? 'we added ' : 'we’ll add ') + andList(sr.map(function (st) { return plainName(st.plan[0].c); })) + ' instead' +
      (n === 1 ? ' (it works well here; see the note in the list).' : ' (they work well here; see the notes in the list).');
  }
  function showMissing() {
    var box = $('ur-oos'), t = [missingText(false), subText(false)].filter(Boolean).join(' ');
    if (box) { box.textContent = t; box.hidden = !t || !$('ur-done').hidden; }
    // the recipe's ingredient list: a quiet note on anything with no same-kind choice in stock
    rows.forEach(function (st) {
      var li = st.r.k == null ? null : document.querySelector('.ur-ing li[data-ur-k="' + st.r.k + '"] .ur-item');
      if (!li) return;
      var tag = li.querySelector('.ur-oos-tag'), out = !sameKind(st.r).length;
      if (out && !tag) { tag = document.createElement('span'); tag.className = 'ur-oos-tag'; li.appendChild(tag); }
      if (out) tag.textContent = 'Out of stock at Umall right now' + (!st.user && st.auto2 && st.on && st.plan.length ? ' · we’ll add ' + plainName(st.plan[0].c) + ' instead' : '');
      if (!out && tag) tag.remove();
    });
  }

  function render() {
    planAll();
    var main = rows.filter(function (s) { return !s.r.pantry; });
    var pantry = rows.filter(function (s) { return s.r.pantry; });
    var h = '';
    if (main.length) h += '<div class="ur-grp">Main ingredients</div>' + main.map(rowHTML).join('');
    if (pantry.length) {
      h += '<div class="ur-grp">Pantry staples</div><p class="ur-grp-hint">Not ticked, as most kitchens have these. Tick any you need.</p>';
      h += pantry.map(rowHTML).join('');
    }
    list.innerHTML = h;
    $('ur-serv').textContent = serves;
    var bs = document.querySelectorAll('[data-ur-serv]');
    bs[0].disabled = serves <= 1; bs[1].disabled = serves >= MAX_SERVES;
    totals();
    showMissing();
  }

  function chosen() {
    var items = [];
    rows.forEach(function (s) {
      if (!s.on) return;
      s.plan.forEach(function (l) { items.push({ id: l.c.id, pid: l.c.pid, quantity: l.q, cost: lineCost(l.c, l.q), label: s.r.label, title: l.c.t }); });
    });
    return items;
  }
  function totals() {
    var items = chosen(), sum = 0;
    items.forEach(function (it) { sum += it.cost; });
    var nRows = rows.filter(function (s) { return s.on && s.plan.length; }).length;
    document.querySelectorAll('[data-ur-n]').forEach(function (e) { e.textContent = nRows; });
    document.querySelectorAll('[data-ur-t]').forEach(function (e) { e.textContent = money(sum); });
    document.querySelectorAll('[data-ur-tw]').forEach(function (e) { e.hidden = false; });
    addBtn.disabled = pending || (!attempt && items.length === 0);
    addBtn.setAttribute('aria-busy', pending ? 'true' : 'false');
    if (attempt) {
      free.textContent = 'Checking your cart total…';
    } else if (cart) {
      var left = D.freeAt - cartTotal - (added ? 0 : sum);
      free.innerHTML = left > 0
        ? 'Add <b>A$' + money(left) + '</b> more for free Sydney standard delivery'
        : 'Free Sydney standard delivery on this order (A$69+)';
      free.innerHTML += '. A$2.50 packing service fee still applies.';
    }
  }

  /* ---------- swap picker ---------- */
  var pick = $('ur-pick'), pickList = $('ur-pick-list'), pickRow = null, pickSel = null, lastFocus = null;
  function openPick(st) {
    pickRow = st; pickSel = st.on ? st.sel : -1;
    var r = st.r, prob = primaryProblem(r);
    $('ur-pick-t').textContent = 'Choose ' + r.label;
    $('ur-pick-s').textContent = 'Recipe needs ' + forText(st) + '.' +
      (prob ? ' ' + (prob.who ? prob.who + ' ' : 'Our usual pick ') + prob.why + '.' : '');
    drawPick();
    lastFocus = document.activeElement;
    pick.hidden = false;
    var f = pickList.querySelector('[aria-checked="true"]') || pickList.querySelector('button:not(:disabled)');
    if (f) f.focus();
  }
  function optionHTML(st, c, k) {
    var r = st.r, n = packsFor(r, c);
    var limited = c.lim && (cartQty[c.pid] || 0) >= c.lim;
    var ok = c.a && !limited;
    return '<button type="button" class="ur-op" role="radio" data-k="' + k + '" aria-checked="' + (pickSel === k) + '"' + (ok ? '' : ' disabled') + '>' +
      '<span class="ur-rd"></span>' + thumb(c) +
      '<span class="ur-name">' + esc(name(c)) +
      '<span class="ur-tag' + (ok ? '' : ' is-out') + '">' +
        (!c.a ? 'Sold out' : limited ? 'Limit ' + c.lim + ' per order, already in your cart' : 'In stock' + (c.pri ? ' · recipe pick' : '') + ' · ' + plural(n, 'pack')) +
      '</span>' + badges(c) +
      (c.nt && !c.pri ? '<span class="ur-note2">' + esc(c.nt) + '</span>' : '') + '</span>' +
      '<span class="ur-price">A$' + money(lineCost(c, n)) + '</span></button>';
  }
  function drawPick() {
    var st = pickRow, r = st.r, h = '';
    var same = [], subs = [];
    r.c.forEach(function (c, k) { if (c.gone) return; (c.kd === 'sub' ? subs : same).push(optionHTML(st, c, k)); });
    if (same.length) h += '<p class="ur-pick-grp">Same ingredient, other brand or size</p>' + same.join('');
    if (subs.length) h += '<p class="ur-pick-grp">Substitutes (a different ingredient; changes the dish a little)</p>' + subs.join('');
    h += '<button type="button" class="ur-op is-skip" role="radio" data-k="-1" aria-checked="' + (pickSel === -1) + '"><span class="ur-rd"></span><span class="ur-name">Skip this ingredient</span></button>';
    pickList.innerHTML = h;
  }
  function closePick(apply) {
    if (apply && pickRow && !pending) {
      added = false;
      if (pickSel === -1) { pickRow.on = false; }
      else { pickRow.sel = pickSel; pickRow.on = true; }
      pickRow.user = true;
      render();
    }
    pick.hidden = true; pickRow = null;
    if (lastFocus && lastFocus.focus) lastFocus.focus();
  }
  pickList.addEventListener('click', function (ev) {
    var b = ev.target.closest('.ur-op');
    if (!b || b.disabled) return;
    pickSel = Number(b.getAttribute('data-k'));
    drawPick();
  });
  pick.addEventListener('click', function (ev) {
    if (ev.target === pick) closePick(false);
    if (ev.target.closest('[data-ur-pick-done]')) closePick(true);
  });

  /* ---------- list events ---------- */
  list.addEventListener('click', function (ev) {
    if (pending) return;
    var row = ev.target.closest('.ur-row');
    if (!row) return;
    var st = rows[Number(row.getAttribute('data-i'))];
    if (ev.target.closest('[data-chg]')) { ev.preventDefault(); openPick(st); return; }
    if (ev.target.closest('a')) return;
    if (st.sel < 0) { if (st.r.c.some(avail)) openPick(st); return; }
    added = false; st.on = !st.on; st.user = true;
    render();
  });
  document.querySelectorAll('[data-ur-serv]').forEach(function (b) {
    b.addEventListener('click', function () {
      if (pending) return;
      added = false; serves = Math.min(MAX_SERVES, Math.max(1, serves + Number(b.getAttribute('data-ur-serv'))));
      render();
    });
  });

  /* ---------- phone bottom sheet ---------- */
  var html = document.documentElement, scrim = $('ur-scrim'), openers = document.querySelectorAll('[data-ur-open]');
  function openSheet() {
    if (!mq.matches) return false;
    html.classList.add('ur-sheet-open'); scrim.hidden = false;
    openers.forEach(function (b) { b.setAttribute('aria-expanded', 'true'); });
    recheck();
    return true;
  }
  function closeSheet() {
    html.classList.remove('ur-sheet-open'); scrim.hidden = true;
    openers.forEach(function (b) { b.setAttribute('aria-expanded', 'false'); });
  }
  openers.forEach(function (b) {
    b.addEventListener('click', function (ev) { if (openSheet()) ev.preventDefault(); });
  });
  scrim.addEventListener('click', closeSheet);
  document.querySelectorAll('[data-ur-close]').forEach(function (b) { b.addEventListener('click', closeSheet); });
  document.addEventListener('keydown', function (ev) {
    if (ev.key !== 'Escape') return;
    if (!pick.hidden) closePick(false); else closeSheet();
  });

  function bottomOffset() {
    var tb = document.querySelector('.kalles_toolbar, #kalles-section-toolbar_mobile, .t4s-toolbar-mobile');
    var off = 0;
    if (tb && mq.matches) {
      var cs = getComputedStyle(tb), rc = tb.getBoundingClientRect();
      if (cs.position === 'fixed' && cs.display !== 'none' && rc.height > 0 && rc.height < 140 && rc.bottom >= window.innerHeight - 2) off = Math.round(rc.height);
    }
    document.querySelectorAll('.ur, .ur-buybar').forEach(function (e) { e.style.setProperty('--ur-bottom', off + 'px'); });
  }

  /* ---------- live availability and prices ---------- */
  var checked = false, checking = null;
  function recheck(force) {
    if (checking) return checking;
    if (checked && !force) return Promise.resolve(); checked = true;
    var handles = {};
    rows.forEach(function (st) { st.r.c.forEach(function (c) { if (!c.test) (handles[c.h] = handles[c.h] || []).push(c); }); });
    var keys = Object.keys(handles), k = 0;
    function next() {
      if (k >= keys.length) return Promise.resolve();
      var h = keys[k++];
      return fetch(root + 'products/' + encodeURIComponent(h) + '.js', { credentials: 'same-origin' })
        .then(function (res) {
          if (res.status === 404) { handles[h].forEach(function (c) { c.a = false; c.gone = true; }); return null; }
          return res.ok ? res.json() : null;
        })
        .then(function (p) {
          if (!p || !p.variants) return;
          var byId = {};
          p.variants.forEach(function (v) { byId[v.id] = v; });
          handles[h].forEach(function (c) {
            var v = byId[c.id];
            if (!v) { c.a = false; c.gone = true; return; }
            c.a = !!v.available; c.p = v.price; c.cp = v.compare_at_price || 0;
            if (c.de && c.p !== c.de.n) delete c.de; // the Daily Essentials deal only applies at its normal price
          });
        })
        .catch(function () {})
        .then(next);
    }
    checking = Promise.all([next(), next(), next(), next()]).then(function () {
      rows.forEach(function (st) {
        var cur = st.r.c[st.sel];
        if (st.user && cur && !avail(cur)) { st.user = false; } // the shopper's pick sold out meanwhile
      });
      render();
      checking = null;
    });
    return checking;
  }

  /* ---------- cart ---------- */
  function readCart(c) {
    cart = c; cartTotal = c.total_price || 0; cartQty = {};
    (c.items || []).forEach(function (it) { cartQty[it.product_id] = (cartQty[it.product_id] || 0) + it.quantity; });
    testInCart.forEach(function (pid) { cartQty[pid] = (cartQty[pid] || 0) + 1; });
    return c;
  }
  function loadCart(strict) {
    return fetch(root + 'cart.js', { credentials: 'same-origin', cache: 'no-store' })
      .then(function (r) { if (!r.ok) throw new Error('Could not read your cart.'); return r.json(); })
      .then(function (c) {
        if (!c || !Array.isArray(c.items) || typeof c.total_price !== 'number') throw new Error('Could not read your cart.');
        return readCart(c);
      }).catch(function (e) { if (strict === true) throw e; return null; });
  }

  // the theme's own way of redrawing the mini cart (same as the flash-sales guard does)
  function refreshMiniCart() {
    var isCartPage = document.body.classList.contains('template-cart');
    return fetch(root + 'cart?view=' + (isCartPage ? 'pagejs' : 'js') + '&_ur=' + Date.now(), { credentials: 'same-origin', cache: 'no-store', headers: { Accept: 'text/html' } })
      .then(function (r) { return r.ok ? r.text() : ''; })
      .then(function (markup) {
        var payload = markup.split('[split_t4nt0]')[1];
        var f = payload && payload.split('[split_t4nt]');
        if (!f || f.length < 5) return;
        var n = String(f[0] || '0').trim();
        Array.from(document.body.classList).forEach(function (k) { if (k.indexOf('t4_cart_count_') === 0) document.body.classList.remove(k); });
        document.body.classList.add('t4_cart_count_' + n);
        document.querySelectorAll('.jsccount').forEach(function (e) { e.textContent = n; });
        [['.js_cat_items', 2], ['.js_cat_dics', 3], ['.js_cat_ttprice', 4]].forEach(function (s) {
          document.querySelectorAll(s[0]).forEach(function (e) { e.innerHTML = f[s[1]]; });
        });
        if (window.jQuery_T4NT) window.jQuery_T4NT('body').trigger('refresh_currency');
      })
      .catch(function () {})
      .then(function () {
        try { document.dispatchEvent(new CustomEvent('cart:refresh')); } catch (e) {}
        try { if (window.jQuery_T4NT && window.jQuery_T4NT.getJSON) window.jQuery_T4NT.getJSON(root + 'cart.js'); } catch (e) {}
      });
  }

  function post(items) {
    // window.fetch is read at call time, so any cart guard that wraps it still sees this request
    return window.fetch(root + 'cart/add.js', {
      method: 'POST', credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: items.map(function (it) { return { id: it.id, quantity: it.quantity }; }) })
    }).then(function (res) {
      return res.json().then(function (j) {
        if (!res.ok) { var e = new Error(j.description || j.message || 'Could not add'); e.status = res.status; throw e; }
        return j;
      });
    });
  }

  // Sum all lines for a variant: discounts/properties can split a Shopify cart line.
  function variantQuantities(c) {
    var qty = {};
    (c.items || []).forEach(function (it) {
      var id = it.variant_id || it.id;
      qty[id] = (qty[id] || 0) + it.quantity;
    });
    return qty;
  }
  function groupItems(items) {
    var grouped = [], byId = {};
    items.forEach(function (it) {
      var entry = byId[it.id];
      if (!entry) {
        entry = { id: it.id, pid: it.pid, quantity: 0, title: it.title, labels: [] };
        byId[it.id] = entry; grouped.push(entry);
      }
      entry.quantity += it.quantity;
      if (entry.labels.indexOf(it.label) < 0) entry.labels.push(it.label);
    });
    return grouped;
  }
  function missingItems(a, c) {
    var qty = variantQuantities(c);
    return a.items.map(function (it) {
      return { id: it.id, quantity: Math.max(0, (a.before[it.id] || 0) + it.quantity - (qty[it.id] || 0)) };
    }).filter(function (it) { return it.quantity > 0; });
  }
  function settleCart() { return new Promise(function (ok) { setTimeout(ok, 700); }); }
  function addMissing(a) {
    // Never retry from the add response: a lost response may already have written the cart.
    return settleCart().then(function () { return loadCart(true); }).then(function (c) {
      var missing = missingItems(a, c), p = Promise.resolve();
      missing.forEach(function (it) {
        p = p.then(function () { return loadCart(true); }).then(function (latest) {
          var stillMissing = missingItems(a, latest).filter(function (entry) { return entry.id === it.id; })[0];
          if (!stillMissing) return;
          // A failed single response is also ambiguous; the next read/final check decides the result.
          return post([stillMissing]).catch(function () {});
        });
      });
      return p;
    });
  }
  function showResult(a, c) {
    var qty = variantQuantities(c), ok = 0, packs = 0, failed = [], adjusted = [];
    a.items.forEach(function (it) {
      var actual = Math.min(it.quantity, Math.max(0, (qty[it.id] || 0) - (a.before[it.id] || 0)));
      if (actual > 0) { ok++; packs += actual; }
      if (actual < it.quantity) failed.push(it.labels.join(' / ') + ' (' + plural(it.quantity - actual, 'pack') + ' missing)');
      var limit = null;
      rows.forEach(function (s) { s.r.c.forEach(function (cc) { if (cc.pid === it.pid && cc.lim) limit = cc.lim; }); });
      if (limit && (cartQty[it.pid] || 0) > limit) adjusted.push(it.title);
    });
    var lines = [];
    if (failed.length) lines.push("Couldn't add: " + failed.join(', ') + '. They may have just sold out or reached a limit.');
    if (adjusted.length) lines.push('Please check your cart: ' + adjusted.join(', ') + ' is over its per-order limit.');
    msg.textContent = lines.join(' ');
    $('ur-done-t').textContent = ok > 0 ? '✓ Added ' + plural(ok, 'item') + ' (' + plural(packs, 'pack') + ') to your cart · cart total A$' + money(cartTotal) : 'Nothing was added';
    var dm = $('ur-done-oos'), mt = [missingText(true, ok > 0), ok > 0 ? subText(true) : ''].filter(Boolean).join(' ');
    if (dm) { dm.textContent = mt; dm.hidden = !mt; }
    $('ur-done').hidden = false;
    added = true; attempt = null;
    addBtn.innerHTML = a.button;
    addBtn.style.display = ok > 0 ? 'none' : '';
    try { (window.dataLayer = window.dataLayer || []).push({ event: 'recipe_buy_all', recipe: D.handle, items: ok, servings: a.serves }); } catch (e) {}
  }
  function planSignature() {
    return JSON.stringify(chosen().map(function (it) { return [it.id, it.quantity, it.cost]; }));
  }
  addBtn.addEventListener('click', function () {
    if (pending) return;
    pending = true; totals(); msg.textContent = 'Checking your cart…';
    $('ur-done').hidden = true;
    var a = attempt, shown = planSignature();
    var work = a ? addMissing(a) : loadCart(true).then(function () { return recheck(true); }).then(function () {
      render(); // Keep pending while limits, stock and prices are recalculated.
      var items = groupItems(chosen());
      if (!items.length) { msg.textContent = 'Nothing left to add.'; return; }
      if (shown !== planSignature()) {
        msg.textContent = 'Stock or prices just changed. Please check the list, then tap Add again.';
        return;
      }
      a = attempt = { items: items, before: variantQuantities(cart), serves: serves, button: addBtn.innerHTML };
      msg.textContent = 'Adding to your cart…';
      return post(items).catch(function () { return addMissing(a); });
    });
    work.then(function () {
      if (!a) return;
      return refreshMiniCart().then(settleCart).then(function () { return loadCart(true); })
        .then(function (c) { showResult(a, c); });
    }).catch(function () {
      if (attempt) {
        added = true; free.textContent = 'Checking your cart total…';
        addBtn.textContent = 'Check cart'; addBtn.style.display = '';
        msg.textContent = 'We couldn’t confirm your cart. Tap Check cart to check this add before trying again.';
      } else {
        msg.textContent = 'Could not check your cart. Please try again.';
      }
    }).then(function () {
      pending = false; render();
      if (attempt) free.textContent = 'Checking your cart total…';
    });
  });

  list.addEventListener('click', function () {
    if (pending) return;
    if (!$('ur-done').hidden) { $('ur-done').hidden = true; addBtn.style.display = ''; showMissing(); }
  }, true);

  /* ---------- in-page links ---------- */
  function bindJumps() {
    var topSet = false;
    function setStickyTop() {
      var c = topCover();
      if (!c) return;
      topSet = true;
      var u = document.querySelector('.ur');
      if (u) u.style.setProperty('--ur-top', Math.round(c + 16) + 'px');
    }
    window.addEventListener('scroll', function () {
      if (topSet || window.pageYOffset < 300) return;
      topSet = true; setTimeout(function () { topSet = false; setStickyTop(); }, 450);
    }, { passive: true });
    window.addEventListener('resize', function () { topSet = false; });
    document.querySelectorAll('.ur-jump a[href^="#"]').forEach(function (a) {
      a.addEventListener('click', function (ev) {
        if (a.hasAttribute('data-ur-open') && mq && mq.matches) return;
        var el = document.getElementById(a.getAttribute('href').slice(1));
        if (!el) return;
        ev.preventDefault();
        jumpTo(el, true);
        if (history.replaceState) history.replaceState(null, '', a.getAttribute('href'));
      });
    });
    if (location.hash.length > 1 && location.hash !== '#buy') {
      var t = document.getElementById(location.hash.slice(1));
      if (t && t.closest('.ur')) window.addEventListener('load', function () { setTimeout(function () { jumpTo(t, false); }, 200); });
    }
  }

  bindJumps();
  render();
  loadCart().then(function (c) { if (c) render(); });
  bottomOffset();
  window.addEventListener('resize', bottomOffset);
  setTimeout(bottomOffset, 1200);
  if (!mq.matches) { (window.requestIdleCallback || setTimeout)(recheck); }
  if (location.hash === '#buy') {
    setTimeout(function () { if (!openSheet()) jumpTo($('buy'), false); }, 300);
  }
})();
